export const environment = {
    production: false,
    PAYMENT_UI: 'https://epms-dev2.ets.org',
    MAX_PAYMENT_ALLOWED_ATTEMPTS: 3,
    PAYPAL_SDK: 'https://www.paypal.com/sdk/js?components=messages,buttons&disable-funding=card&client-id=',
    VERTUAL_TERIMINAL_URL: 'https://epmsadmin-dev2-ui.ets.org/virtual-terminal',
    GTM_APP_ID: 'GTM-MGNHGKX',
    RAZORPAY_SDK:"https://checkout.razorpay.com/v1/checkout.js"
};
